import { useSearchParams } from "react-router"

/**
 * Extracts the graph key from URL search params and strips version suffix.
 * Removes trailing version pattern (_x.y.z) from the graphKey param.
 * @returns The base graph key without version suffix, or empty string if not present.
 */
export function useCurrentGraphFamilyKey() {
  const [searchParams] = useSearchParams({})
  const graphKey = searchParams.get("graphKey") ?? ""
  const currentGraphKey = graphKey.replace(/_\d+\.\d+\.\d+$/, "")
  return currentGraphKey
}
